var Remote = {

	ajax: function(opts) {
		if (player.offline && opts['offline'] != undefined) opts['url'] = "data/" + opts['offline'];
		return $.ajax(opts);
	}
}